var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.84 3.496 10.981.652a.547.547 0 0 0-.772.775l1.918 1.91H.548a.547.547 0 1 0 0 1.093h11.582L10.21 6.34a.547.547 0 0 0 .772.775l2.857-2.844a.547.547 0 0 0 0-.775"
})));
export { SvgIconRight as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-right.14d71c7c.svg";